import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class NewsletterService {
    async getList(params: any): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.NEWSLETTER}`, { params });
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao trazer listagem" }; // Retorna um objeto de erro
        }
    }

    async createNewsletter(newsletter: any): Promise<any> {
        try {
            const response = await BaseAPI.post(`${URLS.NEWSLETTER}`, newsletter);
            return response; // Retorna a resposta da API
        } catch (error) {
            return { error: "Erro ao cadastrar", details: error };
        }
    }

    async editNewsletter(newsletter: any, uuid: string | undefined): Promise<any> {
        try {
            const response = await BaseAPI.put(`${URLS.NEWSLETTER}/${uuid}`, newsletter);
            return response; // Retorna a resposta da API
        } catch (error) {
            return { error: "Erro ao cadastrar", details: error };
        }
    }


    async sendNewsletter(uuid: string | undefined): Promise<any> {
        try {
            const response = await BaseAPI.post(`${URLS.NEWSLETTER}/send?newslettersUuid=${uuid}`);
            return response; // Retorna a resposta da API
        } catch (error) {
            return { error: "Erro ao enviar", details: error };
        }
    }

    async getNewsletterByUuid(uuid: string): Promise<any> {
        try {
            const response = await BaseAPI.get(`${URLS.NEWSLETTER}/${uuid}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao buscar dados" }; // Retorna um objeto de erro
        }
    }


    async deleteNewsletter(uuid: string): Promise<any> {
        try {
            const response = await BaseAPI.delete(`${URLS.NEWSLETTER}/${uuid}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao deletar" }; // Retorna um objeto de erro
        }
    }
}


const newsletterService = new NewsletterService();
export default newsletterService;
